<template>
  <v-col cols="12" lg="3" sm="6">
    <v-card :loading="loading" class="mx-auto" height="180">
      <template #progress>
        <v-progress-linear color="indigo" indeterminate />
      </template>

      <v-card-text class="pb-0">
        <div class="text-h6 font-weight-black">Pessoas com Deficiência (PcD)</div>
      </v-card-text>

      <div v-if="hasData" class="d-flex h-100">
        <div class="position-relative mt-1" style="flex: 0.7">
          <apexchart height="125" :options="chartOptions" :series="series" width="100%" />
        </div>

        <div class="overflow-y-auto pa-3" style="flex: 1; height: 100px">
          <div class="mt-2">
            <div
              v-for="(label, index) in chartOptions.labels"
              :key="label"
              class="d-flex align-center mb-1"
            >
              <span
                class="mr-2"
                :style="{ backgroundColor: getColor(index) }"
                style="
                  border-radius: 3px;
                  display: inline-block;
                  flex-shrink: 0;
                  height: 12px;
                  width: 12px;
                "
              />

              <span class="text-caption"> {{ label }}: {{ series[index] }} </span>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="d-flex align-center justify-center" style="height: 100px">
        <span class="text-grey"> Sem registros de pessoas com deficiência </span>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "DeficientesCard",

  props: {
    franquiaId: {
      default: null,
      type: Number,
    },
  },

  data() {
    return {
      chartOptions: {
        chart: {
          type: "donut",
        },

        colors: [],

        dataLabels: {
          enabled: false,
        },

        labels: [],

        legend: {
          show: false,
        },

        plotOptions: {
          pie: {
            donut: {
              size: "55%",
            },
          },
        },
      },

      colors: [
        "#008FFB",
        "#00E396",
        "#FEB019",
        "#775DD0",
        "#FF4560",
        "#546E7A",
        "#26A69A",
        "#D10CE8",
        "#FF6D00",
        "#7F7F7F",
        "#AEC7E8",
      ],

      loading: false,

      series: [],
    };
  },

  computed: {
    hasData() {
      return this.series.some((value) => value > 0);
    },
  },

  watch: {
    franquiaId: {
      handler(value) {
        this.getDeficientes(value);
      },

      immediate: true,
    },
  },

  methods: {
    async getDeficientes(franquiaId) {
      if (!franquiaId) {
        this.resetChart();
        return;
      }

      this.loading = true;

      try {
        const { deficientes } = await this.$services.professoresService.deficientes(franquiaId);

        this.updateChart(deficientes);
      } catch (error) {
        console.error("Erro ao carregar dados de PcD:", error);
        this.resetChart();
      } finally {
        this.loading = false;
      }
    },

    getColor(index) {
      return this.colors[index % this.colors.length];
    },

    resetChart() {
      this.series = [];

      this.chartOptions = {
        ...this.chartOptions,
        colors: [],
        labels: [],
      };
    },

    updateChart(deficientes) {
      const data = Object.entries(deficientes ?? {});

      this.series = data.map(([, value]) => Number(value) || 0);

      this.chartOptions = {
        ...this.chartOptions,
        colors: data.map((_, index) => this.getColor(index)),
        labels: data.map(([label]) => label),
      };
    },
  },
};
</script>
